import type { FilterOptions } from "@/utils/video";
import { decades, ratingRanges, regions } from "@/mocks/videos";

interface FilterPanelProps {
  activeType: string;
  onTypeChange: (type: string) => void;
  filters: FilterOptions;
  onChange: (next: FilterOptions) => void;
  onReset: () => void;
}

const typeTabs = [
  { type: "movie", label: "电影" },
  { type: "tv", label: "电视剧" },
  { type: "variety", label: "综艺" },
];

function FilterRow({
  label,
  options,
  value,
  onSelect,
}: {
  label: string;
  options: string[];
  value: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 py-3 border-b border-background-300/40 last:border-0">
      <span className="shrink-0 w-16 text-sm text-foreground-500">{label}</span>
      <div className="flex flex-wrap items-center gap-2">
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onSelect(opt)}
            className={`px-3 py-1.5 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
              value === opt
                ? "bg-accent-500 text-background-50 font-medium"
                : "bg-background-200/60 text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
            }`}
          >
            {opt === "全部" ? "全部" : opt}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({
  activeType,
  onTypeChange,
  filters,
  onChange,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="rounded-lg bg-background-100 border border-background-300/50 p-4 md:p-6">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-heading font-semibold text-base text-foreground-950 flex items-center gap-2">
          <i className="ri-filter-3-line text-accent-500" /> 筛选条件
        </h3>
        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer"
        >
          <i className="ri-refresh-line" /> 重置
        </button>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 py-3 border-b border-background-300/40">
        <span className="shrink-0 w-16 text-sm text-foreground-500">类型</span>
        <div className="flex flex-wrap items-center gap-2">
          {typeTabs.map((t) => (
            <button
              key={t.type}
              type="button"
              onClick={() => onTypeChange(t.type)}
              className={`px-3 py-1.5 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                activeType === t.type
                  ? "bg-primary-500 text-background-50 font-medium"
                  : "bg-background-200/60 text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <FilterRow
        label="地区"
        options={regions}
        value={filters.region}
        onSelect={(v) => onChange({ ...filters, region: v })}
      />
      <FilterRow
        label="年代"
        options={decades}
        value={filters.year}
        onSelect={(v) => onChange({ ...filters, year: v })}
      />
      <FilterRow
        label="评分"
        options={ratingRanges}
        value={filters.rating}
        onSelect={(v) => onChange({ ...filters, rating: v })}
      />
    </div>
  );
}